import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=0f2c819d&scoped=true&"
import script from "./payment.vue?vue&type=script&lang=js&"
export * from "./payment.vue?vue&type=script&lang=js&"
import style0 from "./payment.vue?vue&type=style&index=0&id=0f2c819d&prod&lang=scss&scoped=true&"
import style1 from "./payment.vue?vue&type=style&index=1&id=0f2c819d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2c819d",
  null
  
)

export default component.exports